<template>
  <DataTabs />
</template>
    
<script>
import DataTabs from "../components/layout/MultiStageSeparatorTest/DataTabs.vue";
export default {
  components: { DataTabs },
  name: "MultiStageSeparatorTest",
};
</script>